import React from 'react';
import ErrorBox, { orderStatus } from '../../Common/ErrorBox/ErrorBox';
import { withEditable } from '../../Common/EditableLabel';
import { willShowModal } from '../../Common/Modal/Modal';
import { undecorated as MessageContent } from '../../Common/Modal/MessageContent';
import { HTMLTrans } from '../../Common/Translations';
import { checkProjectInOrderItem } from '../../Common/Providers/ProjectApi'

const isInProgress = (ap_status) => orderStatus.PAYMENT_IN_PROGRESS === ap_status;

const withErrorBox = (Component) => (props) => {
  const {
    ap_status
  } = props;

  return (
    <div>
    <Component {...props} />
    {
      isInProgress(ap_status) &&
      <div className='row'>
        <div className='col align-items-center ml-lg-3 mt-3'>
          <ErrorBox status={ap_status}/>
        </div>
      </div>
    }
   </div>
  );
};

const isProjectExistsInOrderItem = (route, uuid) => {
  checkProjectInOrderItem(uuid).then(response => {
    if (response.success) {
      window.location.href = route
    }
  })
}

const EditButton = (props) => {
  const {
    id,
    onEditProject,
    tRoute
  } = props;

  return (
        <a
          href='javascript:void(0);'
          role='button'
          className='btn btn-primary mt-3 mt-lg-0'
          onClick={() => isProjectExistsInOrderItem(tRoute(onEditProject), id)}
          >
          <HTMLTrans id="account.project_viewcomp_edit_button">Edit Project</HTMLTrans>
        </a>
  );
};

const DisabledButton = ({ text = 'In Progress' }) => {
  const statusKey = text
    .toLowerCase()
    .replace(/\s/g, '');

  return (
    <a
      role='button'
      className='btn btn-primary disabled mt-3 mt-lg-0'>
      <HTMLTrans id={`account.project_viewcomp_${statusKey}_button`}>{text}</HTMLTrans>
    </a>
  );
};

const LineItem = (props) => {
  const {
    thumbnail_url = '',
    onEditProject = () => {},
    ap_status,
    ap_project_disabled = false,
    ap_project_disabled_label = 'Not Available',
  } = props;
  
  const isDisabled = isInProgress(ap_status) || ap_project_disabled;
  const btnText = (ap_project_disabled) ? ap_project_disabled_label : 'In Progress';

  return (
    <div className='row justify-content-center'>
      <div className='col-lg-3 col-xl-2 d-flex justify-content-center'><Thumb src={thumbnail_url}/></div>
        <Description isDisabled={isDisabled} {...props}/>
      <div className='col-lg-3 d-flex align-items-lg-center justify-content-center'>
        {isDisabled ? <DisabledButton text={ btnText } />
        : <EditButton onEditProject={onEditProject} {...props} />}
      </div>
    </div>
  );
};

export const ProjectLineItem = withErrorBox(LineItem);

const Title = (props) => {
  const { name } = props;
  return (
    <h4 className='mb-1'>{name}</h4>
  );
};

const Action = ({ label, onClick, disabled = false }) => {
  return <a
    href="javascript:void(0);"
    onClick={disabled ? e => (e.preventDefault()) : onClick }
    className={`text-primary text-nowrap ${disabled ? 'text-gray-lighten-2' : ''}`}>
    <u>{label}</u>
  </a>;
};

const EditableTitle = withEditable(Title);
const PopModalDelete = willShowModal()(Action);

export const Description = (props) => {
  const {
    name = 'Bali Mug',
    create_time = '29/11/2017 23:05',
    update_time = '15/10/2017 08:33',
    deletion_info = { delete_date: '' },
    family = {display_name: {en: ''}},
    onRename = () => {},
    onBlur = () => {},
    onDuplicate = () => {},
    onDelete = () => {},
    onUpdate = () => {},
    isEditing = false,
    isDisabled,
    t
  } = props;

  return (
    <div className='col-md-6 col-xl-7'>
      <EditableTitle onEdit={(value) => {
        onUpdate({
          id: props.id,
          name: value
        });
      }}
      valueKey='name'
      name={name}
      isEditing={isEditing}
      onBlur={onBlur}
    />
      <div className='text-nowrap'><HTMLTrans id="account.project_viewcomp_label_product">Product:</HTMLTrans> {family.display_name.en}</div>
      <div className='d-flex flex-wrap'>
        <div className='project-card-date'>
          <HTMLTrans id="account.project_viewcomp_label_created">Created:</HTMLTrans> <span className="text-nowrap">
          {create_time.split('T')[0]}</span>
        </div>
        <div className='project-card-date'>
          <HTMLTrans id="account.project_viewcomp_label_lastedited">Last Edited:</HTMLTrans> <span className="text-nowrap">
          {update_time.split('T')[0]}</span>
        </div>
        <div className='project-card-date'>
          <HTMLTrans id="account.project_viewcomp_label_will_be_deleted">Will be Deleted by:</HTMLTrans> <span className="text-nowrap">
          {deletion_info.delete_date}</span>
        </div>
      </div>
          <div className='text-primary mt-2 small text-center text-lg-left'>
            <Action
              label={<HTMLTrans id="account.project_viewcomp_action_label_rename">Rename</HTMLTrans>}
              disabled={isDisabled}
              onClick={onRename}
            />&nbsp;|&nbsp;
            <Action
              label={<HTMLTrans id="account.project_viewcomp_action_label_duplicate">Duplicate</HTMLTrans>}
              disabled={isDisabled}
              onClick={onDuplicate}
            />&nbsp;|&nbsp;
            <PopModalDelete disabled={isDisabled} label={'Delete'}>
              {closeModal => (
                <MessageContent
                  closeModal={closeModal}
                  message={{
                    title: t("account.project_viewcomp_delete_message_title", "Delete project"),
                    status: 'info',
                    errorMessage: t("account.project_viewcomp_delete_message_error", `Are you sure to delete the project: ${name} ?`, {"name": name})
                  }}>
                    <div className='modal-footer d-flex justify-content-center'>
                      <button
                        className='btn btn-outline-primary'
                        onClick={() => {
                          closeModal();
                        }}><HTMLTrans id="account.project_viewcomp_cancel_button">Cancel</HTMLTrans></button>
                      <button
                        className='btn btn-primary px-5'
                        onClick={() => {
                          onDelete();
                          closeModal();
                        }}
                      >
                      <HTMLTrans id="account.project_viewcomp_yes_button">Yes</HTMLTrans>
                    </button>
                    </div>
                  </MessageContent>
              )}
            </PopModalDelete>
          </div>
    </div>
  );
};

export const Thumb = (props) => {
  const {
    src = ''
  } = props;
  return (
    <img src={src} className='thumbnail project__thumbnail--border'/>
  );
};



// WEBPACK FOOTER //
// ./src/Account/Project/ViewComp.js